import { render, staticRenderFns } from "./LanguageCertificateCopy.vue?vue&type=template&id=10f80e2c&"
import script from "./LanguageCertificateCopy.vue?vue&type=script&lang=js&"
export * from "./LanguageCertificateCopy.vue?vue&type=script&lang=js&"
import style0 from "./LanguageCertificateCopy.vue?vue&type=style&index=0&id=10f80e2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports